import { useEffect } from 'react';

/** 兜底：把 configuration 写入 CSS 变量（#rrggbb 生效） */
function applyThemeCSSVariables(configuration) {
    if (!configuration || typeof configuration !== 'object') return;
    const root = document.documentElement;
    Object.entries(configuration).forEach(([key, hex]) => {
        if (!hex) return;
        root.style.setProperty(`--${key}`, String(hex));
    });
}

/** 预览桥：仅在 ?preview=1 时监听来自 manage.platypus360.com 的主题注入 */
export function PreviewThemeBridge() {
    // console.log('[ThemePreview] PreviewThemeBridge init');
    /** 统一入口：优先调用全局 setter，兜底写 CSS 变量 + 记忆到 window.__PREVIEW_THEME */
    function pushPreview(payload) {
        // console.log('[ThemePreview] pushPreview called', payload);
        const configuration = payload?.configuration || payload;
        // console.log('[ThemePreview] pushPreview', configuration, payload);
        if (!configuration || typeof configuration !== 'object') return;

        if (typeof window.__APPLY_PREVIEW_THEME__ === 'function') {
            try {
                window.__APPLY_PREVIEW_THEME__({ configuration, colors: payload?.colors });
            } catch (e) {
                console.warn('[ThemePreview] __APPLY_PREVIEW_THEME__ failed, fallback to CSS vars', e);
                applyThemeCSSVariables(configuration);
            }
        } else {
            applyThemeCSSVariables(configuration);
        }
        // console.log('[ThemePreview] theme applied');

        // 统一记忆
        window.__PREVIEW_THEME = { configuration, colors: payload?.colors };
    }
    
    useEffect(() => {
        if (!window.location.search.includes('preview=1')) return;

        const allowed = new Set([
            window.origin,                    // 预览页自身
            'https://manage.platypus360.com', // 线上 CMS
            'http://192.168.0.190:3003',      // 你的预览开发域（可留）
        ]);

        // 自动加入父页面（CMS）的 origin，避免端口变动导致丢消息
        try {
            if (document.referrer) {
                const parentOrigin = new URL(document.referrer).origin;
                allowed.add(parentOrigin);
                // console.log('[ThemePreview] parent origin from referrer:', parentOrigin);
            }
        } catch { }

        // console.log('[ThemePreview] enabled. Allowed origins:', [...allowed]);

        // 初始化：只有存在时才应用一次，避免 pushPreview(undefined)
        if (window.__PREVIEW_THEME?.configuration) {
            // console.log('[ThemePreview] apply existing window.__PREVIEW_THEME');
            pushPreview(window.__PREVIEW_THEME);
        }

        const isHMR = (d) => {
            const t = d && d.type;
            return typeof t === 'string' &&
                (t === 'webpackOk' || t === 'webpackInvalid' || t?.startsWith('webpackHotUpdate'));
        };

        const handler = (e) => {
            // 临时：看见不在白名单的消息就打个 dropped 帮定位
            if (!allowed.has(e.origin)) {
                // 注：上线后可以删掉这条日志
                console.debug('[ThemePreview] dropped message from', e.origin, e.data?.type);
                return;
            }

            const data = e.data;
            if (isHMR(data)) return; // 忽略 webpack HMR 垃圾消息

            let payload = null;
            if (data?.type === 'PREVIEW_THEME') payload = data.payload;
            else if (data?.__PREVIEW_THEME) payload = data.__PREVIEW_THEME;

            if (!payload?.configuration || typeof payload.configuration !== 'object') return;

            // console.log(
            //     '[ThemePreview] message received PREVIEW_THEME, keys=',
            //     Object.keys(payload.configuration)
            // );
            pushPreview(payload);
        };

        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, []);

    return null;
}
